import React from "react";
import { motion } from "framer-motion";
import image from "../assets/svg/team-work.svg";

const CallToAction = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100 pt-24 md:pt-32 text-center border-b-4 border-[#BDE9FB]">
      <motion.div
        className="max-w-[90%] md:max-w-[80%] lg:max-w-[60%] mx-auto lg:mt-56 sm:-mt-20"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeInOut" }}
        viewport={{ once: false, amount: 0.2 }}
      >
        <h1 className="text-lg sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 leading-snug">
          Supercharge your business with our cutting-edge ERP solutions!
          <br />
          Designed to boost productivity and fuel sustainable growth, we're here
          to help you unlock your full potential and achieve amazing!
        </h1>

        <motion.div
          className="mt-6 md:mt-8 flex justify-center lg:-mt-12"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1.0, ease: "easeInOut", delay: 0.3 }}
          viewport={{ once: false, amount: 0.2 }}
        >
          <motion.img
            src={image}
            alt="team-work"
            className="w-full max-w-[700px] h-auto"
            whileHover={{ y: -20 }} // Increase size by 10% and move up by 10px on hover
            transition={{ duration: 0.3, ease: "easeInOut" }}
          />
        </motion.div>
      </motion.div>
    </div>
  );
};

export default CallToAction;
